import { typedQueryClient } from "hooks";
import { QUESTION_ELEMENT_TEMPLATES } from "models";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";

import type { Checklist, ChecklistID, DealerID, DealerLocationID, Question } from "models";

export enum CHECKLIST_LISTS {
  Location = "location",
  Dealer = "dealer",
  Default = "default"
}

export const sortChecklistsByName = (checklists: Checklist[]) => checklists.toSorted((a, b) => a.name.localeCompare(b.name));

export const sortQuestionsByTitle = (questions: Question[]) => questions.toSorted((a, b) => (a.title ?? "").localeCompare(b.title ?? ""));

export const hasTyreElement = (question: Question) =>
  question.contains_tyre_element || question.question_elements?.some(qe => qe.template === QUESTION_ELEMENT_TEMPLATES.Tyre);

export const getChecklistById = (id: ChecklistID, dealerId?: DealerID, locationId?: DealerLocationID) =>
  typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.defaultChecklists)?.find(checklist => checklist.id === id) ??
  typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealerId))?.find(checklist => checklist.id === id) ??
  typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(locationId))?.find(checklist => checklist.id === id);

export const removeLocationChecklist = (locationChecklists: Checklist[], checklistIdx: number) => {
  const removedDisplayOrder = locationChecklists[checklistIdx].display_order ?? 0;

  return locationChecklists
    .toSpliced(checklistIdx, 1)
    .map(lc => ((lc.display_order ?? 0) > removedDisplayOrder ? { ...lc, display_order: (lc.display_order ?? 0) - 1 } : lc));
};
